/**
 * Cart Shipping Notice Injector for Tomb45
 * Adds cart attributes for products with shipping notices to display in checkout
 */

(function() {
  'use strict';

  const CHECKOUT_NOTICE = 'Note: Order includes back-ordered plastic LED pad shipping separately (Feb 2025). Rubber pad ships immediately.';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const checkoutButton = document.querySelector('button[name="checkout"]');
    if (!checkoutButton) return;

    checkoutButton.addEventListener('click', handleCheckoutClick);
  }

  function handleCheckoutClick(e) {
    const noticeElements = document.querySelectorAll('.shipping-notice');

    if (noticeElements.length === 0) {
      return; // No notice products, proceed normally
    }

    e.preventDefault();
    const checkoutForm = e.target.closest('form');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'Shipping Notice': CHECKOUT_NOTICE }
      })
    })
    .then(response => response.json())
    .then(() => checkoutForm.submit())
    .catch(() => checkoutForm.submit()); // Graceful fallback
  }
})();
